import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardBody } from '@nextui-org/react';
import HeaderComponent from '../components/General/HeaderComponent';
import { FiMail, FiUsers, FiHelpCircle, FiShare2 } from 'react-icons/fi';
import { MdOutlinePushPin, MdPushPin } from 'react-icons/md';
import { BsActivity, BsQrCode, BsBuildings } from 'react-icons/bs';
import { CgDatabase } from 'react-icons/cg';
import { AiOutlineCalendar } from 'react-icons/ai';
import { VscLayoutMenubar } from 'react-icons/vsc';

const FAVORITE_MODULES_KEY = 'favoriteModules';

export default function Deck() {
  const navigate = useNavigate();
  const [favoriteModuleIds, setFavoriteModuleIds] = useState([]);

  // localStorage'dan favori modülleri yükle
  useEffect(() => {
    const saved = localStorage.getItem(FAVORITE_MODULES_KEY);
    if (saved) {
      try {
        setFavoriteModuleIds(JSON.parse(saved));
      } catch (e) {
        console.error('Favori modüller yüklenirken hata:', e);
      }
    }
  }, []);

  // Favori modül ekle/çıkar
  const toggleFavorite = (moduleId, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.nativeEvent) {
      e.nativeEvent.stopImmediatePropagation();
    }
    
    const isCurrentlyFavorite = favoriteModuleIds.includes(moduleId);
    const newFavorites = isCurrentlyFavorite
      ? favoriteModuleIds.filter(id => id !== moduleId)
      : [...favoriteModuleIds, moduleId];
    

    
    setFavoriteModuleIds(newFavorites);
    localStorage.setItem(FAVORITE_MODULES_KEY, JSON.stringify(newFavorites));
    
    // Custom event gönder - Leftbar'ın güncellenmesi için
    const event = new CustomEvent('favoriteModulesChanged', {
      detail: { favoriteModuleIds: newFavorites },
      bubbles: true,
      cancelable: true
    });
    
    // Hemen gönder
    window.dispatchEvent(event);
    
    // React state güncellemesinden sonra tekrar gönder
    setTimeout(() => {
      window.dispatchEvent(event);
    }, 10);
  };

  // Modül kartları - Sidebar menülerine yönlendirme
  const modules = [
    {
      id: 1,
      title: 'Dashboard',
      description: 'Ana sayfa ve genel bakış',
      icon: <BsActivity className="w-6 h-6" />,
      iconComponent: BsActivity,
      color: 'text-red-600 dark:text-red-400',
      bgColor: 'bg-red-50 dark:bg-red-900/20',
      link: '/dashboard',
      sidebarLabel: 'DASHBOARD',
      sidebarPath: 'dashboard',
      isDefault: true
    },
    {
      id: 2,
      title: 'Projeler',
      description: 'Tüm projelerinizi yönetin ve takip edin',
      icon: <CgDatabase className="w-6 h-6" />,
      iconComponent: CgDatabase,
      color: 'text-blue-600 dark:text-blue-400',
      bgColor: 'bg-blue-50 dark:bg-blue-900/20',
      link: '/projects',
      sidebarLabel: 'PROJELER',
      sidebarPath: 'projects',
      isDefault: true
    },
    {
      id: 3,
      title: 'Takvim',
      description: 'Etkinliklerinizi planlayın ve yönetin',
      icon: <AiOutlineCalendar className="w-6 h-6" />,
      iconComponent: AiOutlineCalendar,
      color: 'text-green-600 dark:text-green-400',
      bgColor: 'bg-green-50 dark:bg-green-900/20',
      link: '/calendar',
      sidebarLabel: 'TAKVİM',
      sidebarPath: 'calendar',
      isDefault: true
    },
    {
      id: 4,
      title: 'Notlar',
      description: 'Önemli notlarınızı kaydedin',
      icon: <VscLayoutMenubar className="w-6 h-6" />,
      iconComponent: VscLayoutMenubar,
      color: 'text-yellow-600 dark:text-yellow-400',
      bgColor: 'bg-yellow-50 dark:bg-yellow-900/20',
      link: '/notes',
      sidebarLabel: 'NOTLAR',
      sidebarPath: 'notes',
      isDefault: true
    },
    {
      id: 5,
      title: 'Organizasyon',
      description: 'Organizasyonlarınızı yönetin',
      icon: <BsBuildings className="w-6 h-6" />,
      iconComponent: BsBuildings,
      color: 'text-indigo-600 dark:text-indigo-400',
      bgColor: 'bg-indigo-50 dark:bg-indigo-900/20',
      link: '/organizations',
      sidebarLabel: 'ORGANİZASYON',
      sidebarPath: 'organizations',
      isDefault: true
    },
    {
      id: 6,
      title: 'Mail Yönetimi',
      description: 'E-posta hesaplarınızı yönetin',
      icon: <FiMail className="w-6 h-6" />,
      color: 'text-purple-600 dark:text-purple-400',
      bgColor: 'bg-purple-50 dark:bg-purple-900/20',
      link: '/mail-management',
      comingSoon: true
    },
    {
      id: 7,
      title: 'Sosyal Medya',
      description: 'Sosyal medya hesaplarınızı yönetin',
      icon: <FiShare2 className="w-6 h-6" />,
      iconComponent: FiShare2,
      color: 'text-pink-600 dark:text-pink-400',
      bgColor: 'bg-pink-50 dark:bg-pink-900/20',
      link: '/social-media',
      sidebarLabel: 'SOSYAL MEDYA',
      sidebarPath: 'social-media',
      comingSoon: true
    },
    {
      id: 8,
      title: 'İnsan Kaynakları',
      description: 'Çalışanlarınızı ve işe alımları yönetin',
      icon: <FiUsers className="w-6 h-6" />,
      iconComponent: FiUsers,
      color: 'text-teal-600 dark:text-teal-400',
      bgColor: 'bg-teal-50 dark:bg-teal-900/20',
      link: '/human-resources',
      sidebarLabel: 'İNSAN KAYNAKLARI',
      sidebarPath: 'human-resources',
      comingSoon: true
    },
    {
      id: 9,
      title: 'Help Desk',
      description: 'Destek taleplerini yönetin ve takip edin',
      icon: <FiHelpCircle className="w-6 h-6" />,
      iconComponent: FiHelpCircle,
      color: 'text-orange-600 dark:text-orange-400',
      bgColor: 'bg-orange-50 dark:bg-orange-900/20',
      link: '/help-desk',
      sidebarLabel: 'HELP DESK',
      sidebarPath: 'help-desk',
      comingSoon: true
    }
  ];

  // Araç kartları - Sadece QR Generator
  const tools = [
    {
      id: 1,
      title: 'QR Generator',
      description: 'QR kod oluşturun ve paylaşın',
      icon: <BsQrCode className="w-5 h-5" />,
      color: 'text-blue-600 dark:text-blue-400',
      link: '/tools/qr-generator'
    }
  ];

  return (
    <div className="w-full dark:bg-dark-100 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 py-6">
        <HeaderComponent title="Deck" />
        
        {/* Modül Kartları */}
        <div className="mb-8">
          <h2 className="text-lg font-semibold text-[#283252] dark:text-darkWhite-300 mb-4 px-4">
            Modüller
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {modules.map((module) => (
              <Card
                key={module.id}
                className={`border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 h-full w-full shadow-none ${
                  module.comingSoon 
                    ? 'opacity-60 cursor-not-allowed' 
                    : 'hover:border-gray-300 dark:hover:border-dark-400 transition-colors'
                }`}
                isPressable={false}
              >
                <CardBody className="p-5 h-full flex flex-col relative">
                  {/* Pin İkonu - Sağ Üst Köşe (Sadece default olmayan modüller için) */}
                  {!module.isDefault && (
                    <button
                      onClick={(e) => toggleFavorite(module.id, e)}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      className={`absolute top-3 right-3 z-20 p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors ${
                        module.comingSoon ? 'opacity-60' : ''
                      }`}
                      aria-label={favoriteModuleIds.includes(module.id) ? 'Favorilerden çıkar' : 'Favorilere ekle'}
                      type="button"
                    >
                      {favoriteModuleIds.includes(module.id) ? (
                        <MdPushPin 
                          className="w-5 h-5 text-blue-600 dark:text-blue-400 transition-colors"
                        />
                      ) : (
                        <MdOutlinePushPin 
                          className="w-5 h-5 text-gray-400 dark:text-gray-500 transition-colors"
                        />
                      )}
                    </button>
                  )}
                  
                  <div 
                    className={`flex items-start gap-4 h-full ${!module.comingSoon ? 'cursor-pointer' : ''}`}
                    onClick={(e) => {
                      // Pin butonuna tıklanmadıysa navigate yap
                      if (e.target.closest('button[aria-label*="Favori"]') || 
                          e.target.closest('svg[class*="FiMapPin"]') ||
                          e.target.closest('button[type="button"]')) {
                        return;
                      }
                      if (!module.comingSoon && module.link && module.link !== '#') {
                        navigate(module.link);
                      }
                    }}
                  >
                    <div className={`${module.bgColor} ${module.color} p-3 rounded-lg flex-shrink-0 ${module.comingSoon ? 'opacity-50' : ''}`}>
                      {module.icon}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <h3 className="text-base font-semibold text-[#283252] dark:text-darkWhite-300">
                          {module.title}
                        </h3>
                        {module.comingSoon && (
                          <span className="px-2 py-0.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 text-xs font-medium rounded-full">
                            Çok Yakında
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {module.description}
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))}
          </div>
        </div>

        {/* Araç Kartları */}
        <div>
          <h2 className="text-lg font-semibold text-[#283252] dark:text-darkWhite-300 mb-4 px-4">
            Araçlar
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {tools.map((tool) => (
              <Card
                key={tool.id}
                className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 cursor-pointer hover:border-gray-300 dark:hover:border-dark-400 transition-colors h-full w-full shadow-none"
                isPressable
                onPress={() => tool.link && navigate(tool.link)}
              >
                <CardBody className="p-5 h-full flex flex-col">
                  <div className="flex items-center gap-3 h-full">
                    <div className={`${tool.color} flex-shrink-0`}>
                      {tool.icon}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-base font-semibold text-[#283252] dark:text-darkWhite-300 mb-1">
                        {tool.title}
                      </h3>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {tool.description}
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

